// Angular imports
import { ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

// 3rd party imports
import { RecaptchaComponent } from 'ng-recaptcha';

// CC-Common imports
import { MessageBoxComponent } from 'cc-common';

// Env imports
import { environment } from '../../../environments/environment';

// Service imports
import { ServerErrorService } from '../../_services/shared-services/server-error.service';

export abstract class RecaptchaBaseComponent {
    @ViewChild('reCaptcha', { static: false }) reCaptcha: RecaptchaComponent;
    @ViewChild('messageBox', { static: false }) messageBox: MessageBoxComponent;

    recaptchaSiteKey = environment.reCaptchaSiteKey;
    recaptchaToken = '';

    constructor(protected readonly errorService: ServerErrorService) {
        // This is still an open issue with ngRecaptcha v7 -
        // https://github.com/DethAriel/ng-recaptcha/issues/123
        // Workaround to supress unhandled promise rejection error
        RecaptchaComponent.prototype.ngOnDestroy = function () {
            if (this.subscription) {
                this.subscription.unsubscribe();
            }
        };
    }

    onRecaptchaResolved(token: string): void {
        this.recaptchaToken = token;
    }

    isValidRecaptcha(): boolean {
        return !!this.recaptchaToken && !!this.recaptchaToken.trim().length;
    }

    resetRecaptcha(): void {
        this.recaptchaToken = '';
        if (this.reCaptcha) {
            this.reCaptcha.reset();
        }
    }

    processApiError(error: HttpErrorResponse): void {
        const apiError = error.error;
        if (apiError && apiError.message && apiError.message.indexOf('captcha') !== -1) {
            this.messageBox.showErrorMessage('Invalid Token', apiError.message);
        } else {
            this.errorService.displayError(error);
        }
    }
}
